import styled from '@emotion/styled';

const MenuMobileAvatarContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Divider = styled.hr`
  margin: 0;

  width: 100%;
  border-color: ${({ theme }) => theme.NeutralColorLightHigh};
  opacity: ${({ theme }) => theme.OpacityLevelMedium};

  align-self: center;
`;

const RodapeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const AvatarButton = styled.button`
  border: none;
  margin: 8px 0px 8px 0px;
  padding: 0;
  background: ${({ theme }) => theme.PrimaryActionColorPure};
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
`;

const TermosCondicoesContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: auto;
  padding-top: 16px;
  width: 278px;

  button {
    padding-left: 0;
    align-items: left;
  }
`;

const TermosCondicoesTitulo = styled.div`
  margin-bottom: 8px;
`;

const S = {
  MenuMobileAvatarContent,
  Divider,
  RodapeWrapper,
  AvatarButton,
  TermosCondicoesContent,
  TermosCondicoesTitulo,
};

export default S;
